module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__container"
  }, [_c('div', {
    staticClass: "footer__row"
  }, [_c('div', {
    staticClass: "footer__item"
  }, [_c('div', {
    staticClass: "footer__address-container"
  }, [_c('div', {
    staticClass: "footer__address-loc1"
  }, [_c('a', {
    attrs: {
      "href": _vm.props.information.address_1_url,
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "location"
    }
  }), _c('div', {
    staticClass: "footer__address",
    domProps: {
      "innerHTML": _vm._s(_vm.props.information.address_1)
    }
  })], 1)]), _c('br'), _c('div', {
    staticClass: "footer__address-loc2"
  }, [_c('a', {
    attrs: {
      "href": _vm.props.information.address_2_url,
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "location"
    }
  }), _c('div', {
    staticClass: "footer__address",
    domProps: {
      "innerHTML": _vm._s(_vm.props.information.address_2)
    }
  })], 1)])])]), _c('div', {
    staticClass: "footer__item"
  }, [_c('div', {
    staticClass: "footer__social-links"
  }, _vm._l((_vm.props.links.socail_links), function(link, i) {
    return _c('a', {
      key: i,
      attrs: {
        "href": link.link
      }
    }, [_c('Icon', {
      attrs: {
        "name": link.label
      }
    })], 1)
  }))]), _c('div', {
    staticClass: "footer__item"
  }, [_c('a', {
    staticClass: "footer__button",
    attrs: {
      "href": _vm.props.links.locations.windsong,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Review Prescott Valley Office")])]), _c('a', {
    staticClass: "footer__button",
    attrs: {
      "href": _vm.props.links.locations.ruth,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Review Prescott Office")])])])]), _c('div', {
    staticClass: "footer__row"
  }, [_c('div', {
    staticClass: "footer__rooster-grin"
  }, [_c('p', [_vm._v(" © Copyright "), _c('span', [_vm._v(_vm._s(new Date().getFullYear()) + " ")]), _c('span', [_vm._v("| ")]), _c('span', {
    attrs: {
      "id": "accessibilityWidget"
    }
  }, [_vm._v("Click for Accessibility ")]), _c('span', [_vm._v("| ")]), _vm._v("Powered by"), _c('a', {
    attrs: {
      "href": "https://www.roostergrin.com",
      "target": "_blank"
    }
  }, [_vm._v("Rooster Grin Media")])])])])]), _c('div', {
    staticClass: "footer__custom-scripts",
    domProps: {
      "innerHTML": _vm._s(_vm.props.scripts)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55fe39ec","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 567
// module chunks = 1